import { recentTradeRowCount } from 'constants/widgetRowCount'
import reverse from 'lodash/reverse'
import sortBy from 'lodash/sortBy'
import uniqBy from 'lodash/uniqBy'

import { TradesActionType } from './actions'
import * as AT from './actionTypes'
import { TradeType } from './types'

export type TradesStateType = {
  readonly all: Array<TradeType>
  readonly subscribed: boolean
}

const initialState = {
  all: [],
  subscribed: false
}

// NB: Not a performant operation, done ONLY at start up
// Optimise befor extending to regular operations
const mergeRecentTrades = (all: TradeType[], recentTrades: TradeType[]): TradeType[] =>
  reverse(sortBy(uniqBy(all.concat(recentTrades), 'trade_id'), ['timestamp']))

const trades = (
  state: TradesStateType = initialState,
  action: TradesActionType
): TradesStateType => {
  switch (action.type) {
    case AT.RESET: {
      return initialState
    }

    case AT.SET_SUBSCRIBED: {
      return {
        ...state,
        subscribed: true
      }
    }

    case AT.SET_UPDATE: {
      return {
        all: mergeRecentTrades(state.all, [action.payload.trade]).slice(0, recentTradeRowCount),
        subscribed: state.subscribed
      }
    }

    case AT.SET_RECENT_TRADES: {
      return {
        all: mergeRecentTrades(state.all, action.payload.recentTrades).slice(
          0,
          recentTradeRowCount
        ),
        subscribed: state.subscribed
      }
    }

    default:
      return state
  }
}

export default trades
